import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "content px-6 pt-0 !pb-8",
  style: {"padding-bottom":"32px !important"}
}
const _hoisted_2 = { class: "container-img flex justify-center mb-4" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "title text-center text-xl font-bold text-neutral-800 mb-2" }, " Batch berhasil dibuat. Lanjut bayar tagihan! ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "sub-title text-center text-sm text-neutral-500 mb-6 max-w-xl mx-auto" }, " Batch berhasil dibuat. Silakan lakukan pembayaran ke nomor rekening pom mitra di bawah ini sesuai nominal yang tertera di masing-masing pom. ", -1)
const _hoisted_6 = {
  key: 0,
  class: "flex justify-center items-center py-8"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-spin pi-spinner text-3xl text-blue-500" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "border border-neutral-200 rounded-lg overflow-hidden mb-6"
}
const _hoisted_10 = { class: "w-full text-sm text-left" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-neutral-100 text-neutral-600 font-semibold border-b border-neutral-200" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "py-3 px-4 text-center" }, "Pom"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-3 px-4 text-center" }, "Bank"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-3 px-4 text-center" }, "No. Rekening"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-3 px-4 text-center" }, "Atas Nama"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-3 px-4 text-center" }, "Nominal")
  ])
], -1)
const _hoisted_12 = { class: "divide-y divide-neutral-200 text-neutral-700" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "py-4 text-center text-neutral-400"
}, "Tidak ada data rekening partner", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "py-3 px-4 text-center" }
const _hoisted_17 = { class: "py-3 px-4 text-center" }
const _hoisted_18 = { class: "py-3 px-4 text-center" }
const _hoisted_19 = { class: "py-3 px-4 text-center" }
const _hoisted_20 = { class: "py-3 px-4 text-center font-medium" }
const _hoisted_21 = { class: "bg-neutral-50 border-t-2 border-neutral-200 font-bold text-neutral-800" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "py-3 px-4 text-center font-bold"
}, "Total", -1)
const _hoisted_23 = { class: "py-3 px-4 text-center font-bold text-blue-600" }
const _hoisted_24 = { class: "flex items-center justify-center gap-4 pb-2" }

import { computed } from 'vue'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import { IPartnerSummary } from '@/composables/pages/externals/fuel-payment-batch/useBatchPaymentConfirm'
import '@/views/components/modal/hjp-confirmation-modal.scss'


export default /*#__PURE__*/_defineComponent({
  __name: 'BatchPaymentConfirmModal',
  props: {
  show: {
    type: Boolean,
    default: false
  },
  partnerSummary: {
    type: Array as () => IPartnerSummary[],
    default: () => []
  },
  grandTotal: {
    type: Number,
    default: 0
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  isSubmitting: {
    type: Boolean,
    default: false
  },
  imgContent: {
    type: String,
    default: () => require('@/assets/img/modal-confirmation/payment-batch.svg')
  }
},
  emits: ['hideDialog', 'onSubmit'],
  setup(__props, { emit }) {

const props = __props

/* global defineProps, defineEmits */




const showModal = computed({
  get: () => props.show,
  set: (val: boolean) => {
    if (!val) {
      emit('hideDialog')
    }
  }
})

const closeDialog = () => {
  emit('hideDialog')
}

const onSubmit = () => {
  emit('onSubmit')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    showHeader: false,
    visible: _unref(showModal),
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(showModal) ? (showModal).value = $event : null)),
    breakpoints: { '960px': '85vw', '640px': '95vw' },
    style: { width: '50vw' },
    modal: true,
    contentClass: "wrap-content-hjp-confirm-modal"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", { class: "header flex justify-end p-4" }, [
        _createElementVNode("i", {
          class: "pi pi-times cursor-pointer text-xl text-neutral-400 hover:text-neutral-600",
          onClick: closeDialog
        })
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: __props.imgContent,
            alt: "Payment Batch",
            class: "max-h-48 object-contain"
          }, null, 8, _hoisted_3)
        ]),
        _hoisted_4,
        _hoisted_5,
        (__props.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("table", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("tbody", _hoisted_12, [
                  (__props.partnerSummary.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_13, _hoisted_15))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.partnerSummary, (item, idx) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: idx,
                      class: "hover:bg-neutral-50"
                    }, [
                      _createElementVNode("td", _hoisted_16, _toDisplayString(item.Name), 1),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(item.MsBankName), 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(item.AccountNumber), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(item.AccountName), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(_unref(rupiahFormat)(item.TotalAmount)), 1)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("tfoot", _hoisted_21, [
                  _createElementVNode("tr", null, [
                    _hoisted_22,
                    _createElementVNode("td", _hoisted_23, _toDisplayString(_unref(rupiahFormat)(__props.grandTotal)), 1)
                  ])
                ])
              ])
            ])),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_unref(Button), {
            label: "Kembali",
            class: "btn-back px-6 py-2.5 rounded-lg w-36 text-center",
            onClick: closeDialog
          }),
          _createVNode(_unref(Button), {
            label: "Lanjut Pembayaran",
            class: "btn-primary bg-blue-500 hover:bg-blue-600 border-blue-500 text-white px-6 py-2.5 rounded-lg w-48 text-center",
            loading: __props.isSubmitting,
            onClick: onSubmit
          }, null, 8, ["loading"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})